import React from 'react';
import { Field } from 'formik';
import { Row, Col, FormGroup, Input, Label, FormFeedback } from 'reactstrap';
import * as dataSeed from '../../shared/DataSeed';

var today = new Date();
var dd = today.getDate();
var mm = today.getMonth() + 1;
var yyyy = today.getFullYear();
if (dd < 10) {
    dd = '0' + dd
}
if (mm < 10) {
    mm = '0' + mm
}
today = yyyy + '-' + mm + '-' + dd;

export const Page1PersonalData = ({ errors, touched, values, state, onGantiPhotoKTP, onGantiPhotoNPWP, setFieldValue }) => (
    <React.Fragment>
        <FormGroup tag="fieldset">
            <legend>Data Diri</legend>
            <div ref={el => { this.el = el; }} />



            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>Status Pernikahan <span className="text-danger">*</span></Label>
                        <Field component="select" name="MaritalStatusId" id="MaritalStatusId"
                            className={errors.MaritalStatusId && touched.MaritalStatusId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                        >
                            <option value="">-- Pilih --</option>
                            {dataSeed.maritalStatuses.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.MaritalStatusId && touched.MaritalStatusId ? (
                            <FormFeedback>{errors.MaritalStatusId}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>

                {(values.MaritalStatusId === "2") ?
                    <Col md="4">
                        <FormGroup>
                            <Label>Nama Pasangan</Label>
                            <Input tag={Field} name="SpouseName" bsSize="sm" disabled={values.MaritalStatusId !== "2"}
                                className={errors.SpouseName && touched.SpouseName ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'} />
                            {errors.SpouseName && touched.SpouseName ? (
                                <FormFeedback>{errors.SpouseName}</FormFeedback>
                            ) : null}
                        </FormGroup>
                    </Col>
                    : null}

                <Col md="4">
                    <FormGroup>
                        <Label>Agama<span className="text-danger">*</span></Label>
                        <Field className={errors.Religion && touched.Religion ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                            component="select" name="Religion"
                            validate={errors.Religion && touched.Religion}>
                            <option value="">-- Pilih --</option>
                            {dataSeed.religions.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.Religion && touched.Religion ? (
                            <FormFeedback>{errors.Religion}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>
            <Row>

                <Col md="4">
                    <FormGroup>
                        <Label>Pendidikan Terakhir<span className="text-danger">*</span></Label>
                        <Field className={errors.EducationId && touched.EducationId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                            component="select" name="EducationId">
                            <option value="">-- Pilih --</option>
                            {dataSeed.educations.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.EducationId && touched.EducationId ? (
                            <FormFeedback>{errors.EducationId}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>

            </Row>
            {(values.MaritalStatusId !== state.MaritalStatusId || values.Religion !== state.Religion || values.IsKTPExpired == 'true') ?
                <Row>
                    <Col md="6" xs="6">
                    <div class="alert alert-danger" role="alert">
                    <b>Data KTP Anda yang ada pada kami sudah expired, Silakan mengupload KTP terbaru Anda</b>
</div>
                        <FormGroup>
                            <Label>Foto KTP<span className="text-danger">*</span> {state.MaritalStatusId} </Label>
                            <br />
                            <Input type="file" accept="image/*" id="PhotoKTP" name="PhotoKTP"
                                onChange={(e) => onGantiPhotoKTP(e, setFieldValue)}
                            />
                            {errors.PhotoKTP && touched.PhotoKTP ? (
                                <FormFeedback>{errors.PhotoKTP}</FormFeedback>
                            ) : null}
                            <img className="img-fluid" src={state.PhotoKTP} alt="" />
                        </FormGroup>
                    </Col>
                </Row>
                : null}
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>NPWP<span className="text-danger">*</span></Label>
                        <Field component="select" name="NPWP"
                            className={errors.NPWP && touched.NPWP ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                        >
                            <option value="">-- Pilih --</option>
                            {dataSeed.nPWPs.map((NPWP, index) =>
                                <option value={NPWP.id} key={index}>{NPWP.name}</option>
                            )}
                        </Field>
                        {errors.NPWP && touched.NPWP ? (
                            <FormFeedback>{errors.NPWP}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>


               
                {/*{(values.NPWP === "2") || (values.NPWP === "3") ?*/}
               
                    {(values.NPWP === "100") || (values.NPWP === "1001") ?
                
                    <React.Fragment>
                        <Col md="4">
                            <FormGroup>
                                <Label>Nomor NPWP<span className="text-danger">*</span></Label>
                                <Input tag={Field} name="NPWPNumber" bsSize="sm" type="text" disabled={(values.NPWP !== "2") && (values.NPWP !== "3")}
                                    className={errors.NPWPNumber && touched.NPWPNumber ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                                    min="1" />
                                {errors.NPWPNumber && touched.NPWPNumber ? (
                                    <FormFeedback>{errors.NPWPNumber}</FormFeedback>
                                ) : null}
                            </FormGroup>
                        </Col>
                    </React.Fragment>
                    : null
                }
                {(values.NPWP === "1") ?
                    <Col md="6">
                        <FormGroup>
                            <Label>Alasan Tidak Memiliki NPWP<span className="text-danger">*</span></Label>
                            <Field component="select" name="NotHavingNPWPReason"
                                className={errors.NPWP && touched.NPWP ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                            >
                                <option value="">-- Pilih --</option>
                                <option value="1">Belum Membuat NPWP</option>
                                <option value="2">Tidak Memenuhi Syarat Sebagai Pemegang NPWP</option>

                            </Field>
                        </FormGroup>
                    </Col>
                    : null}
            </Row>
            {/*{values.NPWPNumber != state.NPWPNumber  && values.NPWP !== '1'?*/}
            {/*<Row>*/}
            {/*    <Col md="6" xs="6">*/}
            {/*        <FormGroup>*/}
            {/*            <Label>Foto NPWP<span className="text-danger">*</span> {state.MaritalStatusId} </Label>*/}
            {/*            <br />*/}
            {/*            <Input type="file" accept="image/*" id="PhotoNPWP" name="PhotoNPWP"*/}
            {/*                onChange={(e) => onGantiPhotoNPWP(e, setFieldValue)}*/}
            {/*            />*/}
            {/*            {errors.PhotoNPWP && touched.PhotoNPWP ? (*/}
            {/*                <FormFeedback>{errors.PhotoNPWP}</FormFeedback>*/}
            {/*            ) : null}*/}
            {/*            <img className="img-fluid" src={state.PhotoNPWP} alt="" />*/}
            {/*        </FormGroup>*/}
            {/*    </Col>*/}
            {/*</Row>*/}
            {/*    : null}*/}
          
            {/*{(values.NPWP === "2") || (values.NPWP === "3") ?*/}
                {(values.NPWP === "100") || (values.NPWP === "101") ?        
        
                <Row>
                    <Col md="12">
                        <FormGroup>
                            <Label>Alamat NPWP<span className="text-danger">*</span></Label>
                            <Input tag={Field} name="NPWPAddress1" bsSize="sm" maxLength={50}
                            className={errors.NPWPAddress1 && touched.NPWPAddress1 ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                             />
                            {errors.NPWPAddress1 && touched.NPWPAddress1 ? (
                                    <FormFeedback>{errors.NPWPAddress1}</FormFeedback>
                                ) : null}
                        </FormGroup>
                    </Col>
                </Row>
                : null
            }

        </FormGroup>
        {/* END: Data Diri */}
    </React.Fragment>
);



// WEBPACK FOOTER //
// ./src/components/PengkinianData/Page1PersonalData.js